module.exports = __webpack_public_path__ + "../resources/images/outlook-97fabb0c35e2d45801070287f96fa58e.svg";